import React from 'react'
import Cropper from 'react-easy-crop'
import './style.css'
import { Button } from 'react-bootstrap';
import { Dialog } from 'primereact/dialog';
import { Avatar } from 'primereact/avatar';
import getCroppedImg from './cropImg';


export default function Image(props) {
  const [crop, setCrop] = React.useState({ x: 0, y: 0 })
  const [zoom, setZoom] = React.useState(1)
  const [visible, setVisible] = React.useState(false);
  const [rotation] = React.useState(0)
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null)
  const [image, setImage] = React.useState(props?.src)
  const [files, setFiles] = React.useState([])
  const [imgIdx, setImgIdx] = React.useState(0)


  const onCropChange = (crop) => {
    setCrop(crop)
  }


  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    console.log(croppedAreaPixels.width / croppedAreaPixels.height)
    setCroppedAreaPixels(croppedAreaPixels)
  }
  const showCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(
        image,
        croppedAreaPixels,
        rotation
      )
      const newFiles = [...files]
      newFiles[imgIdx].crop = croppedImage
      setFiles(newFiles)
      props?.onChange(croppedImage)
    } catch (e) {
      console.error(e)
    }
  }


  const onZoomChange = (zoom) => {
    setZoom(zoom)
  }
  const readFile = (e) => {
    setFiles([])


    let inputFiles = e.target.files
    if (!props.multiple) {
      inputFiles = [e.target.files[0]]
    }
    const newFiles = []
    for (const file of inputFiles) {
      const reader = new FileReader();
      reader.onload = function (ev) {
        if (props.multiple) {
          newFiles.push({ file: ev.target.result, crop: null })
          setFiles([...newFiles])
        } else {
          props?.onChange(ev.target.result)
          setFiles([{ file: ev.target.result, crop: null }])
        }
        console.log("files", newFiles?.length)
      };
      reader.readAsDataURL(file);
    }
    e.target.value = ""
  }


  const headerElement = (
    <div>
      <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" />
    </div>
  );


  const footerContent = (
    <div>
      <Button size="small" onClick={() => { setVisible(false); showCroppedImage() }} autoFocus >OK</Button>
    </div>
  );


  return (
    <>
      <Dialog visible={visible} style={{ height: "320px", minWidth: "320px" }} header={headerElement} footer={footerContent} onHide={() => { if (!visible) return; setVisible(false); }}>
        <div className="crop-container">
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={1}
            cropShape="round"
            showGrid={false}
            onCropChange={onCropChange}
            onCropComplete={onCropComplete}
            onZoomChange={onZoomChange}
          />
        </div>
      </Dialog>


      <div>
        {files?.map((file, idx) => (
          <span key={idx}>
            <img
              onClick={() => { setImage(file?.file); setImgIdx(idx); setVisible(true); }}
              src={file?.crop ? file?.crop : file?.file}
              width="80"
              alt="Preview"
            />
            <label htmlFor={props.name}>Edit</label>
          </span>
        ))}
        <div>
          {props.multiple && (
            <label htmlFor={props.name}>
              {imgIdx} + Add New File
            </label>
          )}
          {(files.length === 0 && !props.multiple) && (
            <label htmlFor={props.name}>
              <Avatar label={"AD"} image={props?.src} size="xlarge" shape={props?.shape} />
            </label>
          )}
        </div>
      </div>


      <input style={{ display: 'none' }} type="file" id={props.name} onChange={(e) => readFile(e)} />
    </>
  )
}
